import { FilterHandler } from '@btime/react-contexts'
import React from 'react'

import { formatPlaceTypePermission } from '../../../utils/helpers/placeTypes'
import PageContent from './PageContent'
import PageHeader from './PageHeader'
import PermissionChecker from '../../session/_shared/PermissionChecker'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import SimpleCrudsTemplate from '../../../components/templates/v2/SimpleCrudsTemplate'
import useRouteParams from '../../../utils/routes/helpers/useParam'

const PlaceLevelsListPage = () => {
  const type = useRouteParams('type')

  return (
    <SimpleCrudsTemplate>
      <PermissionChecker permission={'setup' + formatPlaceTypePermission(type)}>
        <FilterHandler initialState={{ type }}>
          <PageHeader />
          <PageContent />
        </FilterHandler>
        <Separator weight={90} />
      </PermissionChecker>
    </SimpleCrudsTemplate>
  )
}

export default PlaceLevelsListPage
